function axiosError(err) {
  var msg = " ... ";
  try {
    msg = `Error: ${err.response.data.message}`;
    msg += err.response.data.code ? ` (${err.response.data.code})` : "";
  } catch (ex) {
    msg = "Error: ...";
  }

  return msg;
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const validatePhoneNumber = (phone) => {
  const regex = /^[0-9]{10}$/;
  return regex.test(phone);
};

export default {
  axiosError,
  validateEmail,
  validatePhoneNumber,
};



// WEBPACK FOOTER //
// ./client/helpers/index.js